import get from "lodash.get";
import head from "lodash.head";

export const extractText = ({ content }) => get(head(content), "value", "");

export const extractImage = ({ data }) => get(data, ["target", "fields"], {});
